import styled from "styled-components";
import { loader } from "../img";
import DomunIcon from "./domun-icon";
import { theme } from "../theme";

const LoaderStyled = styled.div`
  height: 108px;
  pointer-events: none;
  position: relative;
  width: 108px;
  img {
    animation: rotation 2s infinite linear;
    display: block;
    width: 100%;
  }
  svg {
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  @keyframes rotation {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(359deg);
    }
  }
`;

const Loader = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <LoaderStyled>
      <img src={loader} alt="Loader" />
      <DomunIcon svgColor={theme.colors.black} />
    </LoaderStyled>
  );
};

export default Loader;
